import * as angular from 'angular';
import { GuidHelper } from '../../framework';

import { ComponentDefinition, KeyValuePair } from '../../models';

class GenericSelectController implements angular.IComponentController {
    readonly defaultValue: unknown;
    readonly isDisabled: boolean;
    readonly isRequired: boolean;
    readonly onChange: (value: { newvalue: string }) => void;
    readonly placeholder: string;
    readonly sortAlpha: boolean;
    readonly sortAscending: boolean;

    isLoading: boolean;
    // TODO this should be a readonly and have different display variable
    items: KeyValuePair<unknown, string>[];
    loadingMessage: string;
    model: unknown;
    previousValue: unknown;
    name: string;

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        if (this.model) {
            this.previousValue = this.model;
        }
        this.initDefault();
        this._$scope.$watch(() => this.model, () => this.initDefault());
        if (!this.name) {
            this.name = GuidHelper.getGuid();
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if ((changesObj['items']?.currentValue) || (changesObj['sortAlpha']?.currentValue)) {
            const items = changesObj['items'].currentValue;
            if (items && this.sortAlpha) {
                this.items = this.sortItems(items);
            }
        }
        this.initDefault();
    }

    private initDefault() {
        if (this.model === undefined && this.defaultValue !== undefined) {
            this.model = this.defaultValue;
        }
    }

    private sortItems(items: KeyValuePair<unknown, string>[]): KeyValuePair<unknown, string>[] {
        return items.sort((item1, item2) => {
            if (this.sortAscending) {
                return item2['value'] < item1['value'] ? 1 : item2['value'] > item1['value'] ? -1 : 0;
            } else {
                return item2['value'] > item1['value'] ? 1 : item2['value'] < item1['value'] ? -1 : 0;
            }
        });
    }
}

export const wtGenericSelect: ComponentDefinition = {
    componentId: 'wtGenericSelect',
    controller: GenericSelectController,
    template: require('./genericSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        defaultValue: '<?',
        hasEmptyOption: '<?',
        isDisabled: '<?',
        isRequired: '<?',
        items: '<',
        model: '=',
        name: '@?',
        onChange: '&?',
        placeholder: '<?',
        sortAlpha: '<',
        sortAscending: '<'
    }
};